import React from 'react';
import Heading from '../../components/shared/Heading';
import { StyledSettings } from './StyledSettings';

const Settings = () => {
  return (
    <StyledSettings>
      <Heading headingType="h1">Settings</Heading>
    </StyledSettings>
  );
};

export default Settings;
